import { render, staticRenderFns } from "./ProcessosAtivosAnm.vue?vue&type=template&id=0dc289e8&lang=pug"
import script from "./ProcessosAtivosAnm.vue?vue&type=script&lang=js"
export * from "./ProcessosAtivosAnm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports